(ns dre.pages.admin.help.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.network :as-alias network]
   [dre.pages.admin.help.db :refer [init-db]]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path [:pages :admin :help])

; vvv EVENTS vvv

(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ _]
  {:db init-db
   ::network/request [{:endpoint :admin/help}
                      {:response-content-type :json
                       :on-success [::init-ok]
                       :on-failure [::init-nok]}]}))

(rf/reg-event-fx
 ::init-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response]}]]
  {:db (assoc db :mappings (get-in response [:body :mappings]))
   :fx [[:dispatch [::toggle-loading]]]}))

(rf/reg-event-fx
 ::init-nok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [_ [opts]]
  {:fx [[:dispatch [::toggle-loading]]
        [:dispatch [::network/default-failure opts]]]}))

(rf/reg-event-db
 ::toggle-loading
 [(rf/path db-path)]
 (fn-traced
  [db _]
  (update db :loading? not)))

(rf/reg-event-fx
 ::delete-article
 [rf/trim-v]
 (fn-traced
  [_ [{:keys [help-topic confluence-id]}]]
  {:fx [[::network/request [{:endpoint :admin/help.delete-article}
                            {:request-content-type :json
                             :response-content-type :json
                             :body {:help-topic help-topic
                                    :confluence-id confluence-id}
                             :on-success [::delete-article-ok]}]]]}))

(rf/reg-event-fx
 ::delete-article-ok
 (fn-traced
  [_ _]
  {:fx [[:dispatch [::init]]]}))

(rf/reg-event-fx
 ::on-drag-end
 [rf/trim-v]
 (fn-traced
  [_ [{:keys [help-topic drag-params]}]]
  (let [drag-params (js->clj drag-params :keywordize-keys true)
        current-ordering (get-in drag-params [:active :data :current :sortable :index])
        wanted-ordering (get-in drag-params [:over :data :current :sortable :index])]
    (when (not= current-ordering wanted-ordering)
      {:fx [[::network/request [{:endpoint :admin/help.change-article-order}
                                {:request-content-type :json
                                 :response-content-type :json
                                 :body {:help-topic help-topic
                                        :current-ordering current-ordering
                                        :wanted-ordering wanted-ordering}
                                 :on-success [::on-drag-end-ok]}]]]}))))

(rf/reg-event-fx
 ::on-drag-end-ok
 (fn-traced
  [_ _]
  {:fx [[:dispatch [::init]]]}))

; ---

; vvv SUBS vvv

(rf/reg-sub
 ::state
 (fn [db]
   (get-in db db-path)))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state _]
   (:loading? state)))

(rf/reg-sub
 ::mappings
 :<- [::state]
 (fn [state]
   (:mappings state)))

(defn- compute-datasource
  [x]
  (->> x
       :mappings
       (map #(select-keys % [:title :confluence-id]))
       (assoc x :datasource)))

(rf/reg-sub
 ::topics
 :<- [::mappings]
 (fn [mappings]
   (->> mappings
        (filter #(= "global" (:help-topic %)))
        (sort-by :ordering)
        (map (fn [{:keys [confluence-id] :as topic}]
               (assoc topic :mappings
                      (->> mappings
                           (filter #(= (:help-topic %) confluence-id))
                           (sort-by :ordering)))))
        (map compute-datasource))))
